import { render } from "./PanelGallery.vue?vue&type=template&id=ea7c35fe"
import script from "./PanelGallery.vue?vue&type=script&lang=js"
export * from "./PanelGallery.vue?vue&type=script&lang=js"
script.render = render

export default script